import {
    GETKYCCONFIGURATIONLIST_SUCCESS,
    GETKYCCONFIGURATIONLIST_FAILED,
    RESET_GETKYCCONFIGURATIONLIST,
    LOADING_GETKYCCONFIGURATIONLIST,
    NETWORK_ERROR_GETKYCCONFIGURATIONLIST,
  } from "../types/index";
  
  const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case LOADING_GETKYCCONFIGURATIONLIST:
        return {
          ...state,
          isLoading: true,
          success: false,
          failed: false,
          network: false,
          data: {},
          message: "",
          networkError: "",
        };
      case GETKYCCONFIGURATIONLIST_FAILED:
        return {
          ...state,
          isLoading: false,
          success: false,
          failed: true,
          network: false,
          data: action.payload,
          message: "",
          networkError: "",
        };
      case GETKYCCONFIGURATIONLIST_SUCCESS:
        return {
          ...state,
          isLoading: false,
          success: true,
          failed: false,
          network: false,
          data: action.payload,
          message: "",
          networkError: "",
        };
      case NETWORK_ERROR_GETKYCCONFIGURATIONLIST:
        return {
          ...state,
          isLoading: false,
          success: false,
          failed: false,
          network: true,
          data: {},
          message: "",
          networkError: "",
        };
      case RESET_GETKYCCONFIGURATIONLIST:
        return (state = initialState);
      default:
        return state;
    }
  };
  